import { Row, Col } from "reactstrap";
import "../chmActivities/CHMActivities.css";
import { useDispatch } from "react-redux";
import { Tooltip } from "@mui/material";

/** IECActivitiesFormDetails Component */
export const ICVActivitiesFormDetails = ({ storeICVData, showQCDetails}: any) => {
  const dispatch: any = useDispatch();
  const labelList: any[] = [
    {
      "Application Number": storeICVData?.ncipApplicationId,
      "Season": showQCDetails ? storeICVData?.season : storeICVData?.ncipSeason,
      "State": showQCDetails ? storeICVData?.state : storeICVData?.ncipCropStateName,
      "District" : showQCDetails ? storeICVData?.district : storeICVData?.ncipCropDistrictName,
      "Tehsil/Block": showQCDetails ? storeICVData?.mandal : storeICVData?.ncipCropMandalName,
      "Year": showQCDetails ? storeICVData?.year : storeICVData?.ncipYear,
      "Crop Village Name": showQCDetails ? storeICVData?.village : storeICVData?.ncipCropVillageName,
      "Crop Pattern": storeICVData?.cropPattern,
      "Land Survey Number": showQCDetails? storeICVData?.surveyNumber : storeICVData?.ncipSurveyNumber,
      "Insured Crop Name": storeICVData?.ncipCropName,
      "Crop Name On Field": (storeICVData?.cropNameOnField?.join(', ')),
      "ICV Conducted Date": storeICVData?.icvConductedDate?.split("T")[0]?.split("-")?.reverse()?.join("-"),
      "Crop Sown Status": showQCDetails ? storeICVData?.cropSownStatus ? 'Yes' : "No" : (storeICVData?.cropSownStatus) ?? 'N/A',
      "Land Is Cultivatable": showQCDetails ? storeICVData?.landCultivatableStatus ? 'Yes' : "No" : (storeICVData?.landCultivatableStatus) ?? 'N/A',
      "Surveyor Name": showQCDetails ? storeICVData?.surveyorName : storeICVData?.surveyorName,
      "Surveyor Mobile Number": storeICVData?.surveyorMobileNumber,
      "Comments": showQCDetails ? storeICVData?.surveyRemarks : storeICVData?.comments,
    },
  ];
  
  if(showQCDetails) {
    labelList?.map((each: any, index: number) => {
      delete each['Application Number'];
      delete each['Insured Crop Name'];
      delete each['ICV Conducted Date'];
      const entries = Object.entries(each);
      entries.splice(1, 0, ['Status', storeICVData?.icvStatusDescription]);
      entries.splice(11, 0, ['Survey Completion Date', storeICVData?.surveyCompletionDate?.split("T")[0]?.split("-")?.reverse()?.join("-")]);
      labelList[index] = Object.fromEntries(entries);
    })
  }

  return (
    <div>
      <p className="section-header">Crop Details</p>
      <Row className="py-3 mx-2">
        {Object.keys(labelList[0]).map((value: string, index: number) => {
          return (
            <Col xs={3} md={3} key={`value-${index}`} className="mb-3">
              <p className="header-key">{value}</p>
               <p className="details-key" id={value === 'Status' ? `status-${storeICVData?.icvStatusId}`: ''}>
                <Tooltip
                    title={labelList[0][value]}
                    placement="bottom-start"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: 'black'
                        }
                      }
                    }}
                >
                {labelList[0][value]?.length > 0 ? labelList[0][value] : 'N/A'}
                </Tooltip>
              </p>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};
